import { gameService } from '@core/services/game/GameService';
import { twoDecimals } from '@app/modules/shared/filters/numbers';
import { errorGuard } from '@app/utils';

const COUNTER_CLASS = 'xjackpot__counter'; // same as in css

interface ComponentInstance {
    xJackpotValue: number;
    xJackpotIncrementPerSecond: number;
    detailsFetched: boolean;
    $nextTick: Function;
    createXJackpotCounter: () => HTMLElement;
    addCounterToElement: (element: HTMLElement, counter: HTMLElement) => void;
    startPeriodicCounterUpdate: (counters: HTMLElement[]) => void;
    formatNumber: (number: number) => string;
    updateXJackpotCounter: (counter: HTMLElement) => void;
    startXJackpotCounter: (elements: HTMLElement[]) => void;
    interval: number;
    content: any;
    isLoading: boolean;
    // user must implement findXJackpotElements
    findXJackpotElements: () => HTMLElement[];
}

export default {
    data() {
        return {
            interval: null,
            detailsFetched: false,
        };
    },
    watch: {
        async isFetchFinished(this: ComponentInstance, value: boolean) {
            if (value) {
                const elements = await this.findXJackpotElements();
                if (elements.length === 0) {
                    return;
                }
                this.startXJackpotCounter(elements);
            }
        },
    },
    computed: {
        isFetchFinished(this: ComponentInstance) {
            return !this.isLoading && this.content && this.detailsFetched;
        }
    },
    methods: {
        async setupCounter(this: ComponentInstance) {
            await errorGuard({
                action: async () => {
                    const result = await gameService.getXJackpotDetails();
                    if (result) {
                        const { currentValue, incrementPerSecond } = result;
                        this.xJackpotValue = currentValue;
                        this.xJackpotIncrementPerSecond = incrementPerSecond;
                        this.detailsFetched = true;
                    }
                }
            });
        },
        async startXJackpotCounter(this: ComponentInstance, elements: HTMLElement[]) {
            const counters = elements.map(element => {
                const counter = this.createXJackpotCounter();
                this.addCounterToElement(element, counter);
                return counter;
            });
            this.startPeriodicCounterUpdate(counters);
        },

        createXJackpotCounter(this: ComponentInstance) {
            const counterHtmlElement = document.createElement('div');
            counterHtmlElement.innerText = this.formatNumber(this.xJackpotValue);
            counterHtmlElement.classList.add(COUNTER_CLASS);
            return counterHtmlElement;
        },
        addCounterToElement(this: ComponentInstance, element: HTMLElement, counter: HTMLElement) {
            element.appendChild(counter);
        },
        startPeriodicCounterUpdate(this: ComponentInstance, counters: HTMLElement[]) {
            this.interval = window.setInterval(
                () => {
                    this.xJackpotValue += this.xJackpotIncrementPerSecond;
                    counters.forEach((counter) => this.updateXJackpotCounter(counter));
                },
                1000,
            );
        },
        updateXJackpotCounter(this: ComponentInstance, counter: HTMLElement) {
            counter.innerText = this.formatNumber(this.xJackpotValue);
        },
        formatNumber(value: number) {
            return twoDecimals(value);
        }
    },
    beforeDestroy(this: ComponentInstance) {
        clearInterval(this.interval);
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/wiki/components/XJackpotMixin.ts